import { Badge } from "@/components/ui/badge";
const countries = [{
  name: "Georgia",
  status: "OPENED"
}, {
  name: "Egypt",
  status: "Coming Soon"
}, {
  name: "Philippines",
  status: "Coming Soon"
}, {
  name: "Uzbekistan",
  status: "Coming Soon"
}, {
  name: "Kenya",
  status: "Coming Soon"
}, {
  name: "Rwanda",
  status: "Coming Soon"
}, {
  name: "Kyrgyzstan",
  status: "Coming Soon"
}, {
  name: "Albania",
  status: "Coming Soon"
}];
export default function OurGlobalFootprint() {
  return <section id="our-global-footprint" className="relative bg-background py-24 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-40 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-12">
          {}
          <div className="lg:col-span-4 flex flex-col justify-start">
            <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-foreground mb-6">
              Global Presence
            </h2>
            <p className="text-muted-foreground text-lg max-w-md font-default">
              Moveonix is rapidly expanding its premium mobility ecosystem across key international markets.
            </p>
          </div>

          {}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
              {countries.map((country, i) => <div key={country.name} data-index={i} style={{
              animationDelay: `${i * 100}ms`
            }} className="animate-fade-in flex flex-col items-start justify-between p-6 bg-surface rounded-lg transition-default hover:shadow-md hover:scale-[1.04] hover:ring-1 hover:ring-primary/20 w-full overflow-hidden">
                  <span className={`font-default text-base mb-4 ${country.status === "OPENED" ? "text-foreground font-medium" : "text-muted-foreground font-normal"}`}>
                    {country.name}
                  </span>
                  <Badge variant={country.status === "OPENED" ? "default" : "secondary"} className={country.status === "OPENED" ? "bg-[#C9A15A] text-white hover:bg-[#C9A15A]/90 px-3 py-1 text-[10px] tracking-widest uppercase font-bold rounded-md border-none shadow-sm transition-colors duration-300" : "bg-muted/50 text-muted-foreground/60 hover:bg-muted/50 px-3 py-1 text-[10px] tracking-widest uppercase font-medium rounded-md border border-border/30"}>
                    {country.status === "OPENED" && <span className="mr-1.5 h-1.5 w-1.5 rounded-lg bg-[#2D6A4F] animate-pulse" />}
                    {country.status}
                  </Badge>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}